import { RosterListOptionsType } from '../utils/getSortedRoster';

export const FILTERS = {
  PARTNER: {
    defaultOption: { label: 'All partners', value: '' }
  }
};

export const MATCH_UPS_FILTER_STATUSES = [
  'DEFAULTED',
  'RETIRED',
  'WALKOVER',
  'COMPLETED',
  'ABANDONED'
] as const;

export const ROSTER_SORT_OPTIONS: { label: string; value: RosterListOptionsType }[] = [
  { label: 'Alphabetically', value: 'alphabetically' },
  { label: 'WTN: Low - High', value: 'wtnAsc' },
  { label: 'WTN: High - Low', value: 'wtnDesc' }
];
